import React, { useCallback } from 'react';
import { PurchaseLot } from '../../../../../../types/entities.js';
import styles from './LotItems.module.scss';
import DescriptionList from '../../../../components/DescriptionList.js';
import DescriptionListItem from '../../../../components/DescriptionListItem.js';
import { LotsPurchaseTabProps } from '../LotsPurchaseTab.type.js';
import { formatCurrency } from '../../../../../../utils/formatCurrency.js';

interface Props {
  lot: PurchaseLot;
  reference: LotsPurchaseTabProps['reference'];
  isBidForUnit: boolean;
  isPropDisplayNmcFields: boolean | string;
}

const LotItems: React.FC<Props> = ({
  lot,
  reference,
  isBidForUnit,
  isPropDisplayNmcFields,
}) => {
  const getCodeTitle = useCallback(
    (code: string, codeType: string): string => {
      // @ts-ignore
      const codeInfo = reference?.[`${codeType}ByCode`]?.[code];
      return [codeType !== 'okei' && code, codeInfo?.name]
        .filter(Boolean)
        .join(' ');
    },
    [reference],
  );

  const getDeliveryRegionName = useCallback(
    (code: string): string => {
      const region = reference?.regionsByCode?.[code];
      return `${region?.offName} ${region?.shortName}`;
    },
    [reference],
  );
  return (
    <>
      <h3>Позиции лота</h3>

      {lot.items.map((item, id) => (
        <details key={item.id} open className={styles.item}>
          <summary className={styles.title}>{`Позиция № ${id + 1}`}</summary>
          <DescriptionList>
            <DescriptionListItem
              title="ОКВЭД2"
              definition={getCodeTitle(item?.okved2Code, 'okved2')}
            />

            <DescriptionListItem
              title="ОКПД2"
              definition={getCodeTitle(item?.okpd2Code, 'okpd2')}
            />

            <DescriptionListItem
              title="Кол-во, объём"
              definition={item.quantity}
            />

            <DescriptionListItem
              title="Код единиц измерения"
              definition={getCodeTitle(item?.okeiRefCode, 'okei')}
            />

            {isBidForUnit && isPropDisplayNmcFields && (
              <DescriptionListItem
                title="Начальная (максимальная) цена за единицу"
                definition={formatCurrency(
                  item?.startPrice,
                  lot.startPriceCurrency.characterCode,
                )}
              />
            )}

            <DescriptionListItem
              title="Дополнительная информация"
              definition={item.additionalInfo}
            />
          </DescriptionList>

          {item.deliveryRegion && (
            <>
              <h4>Место поставки</h4>
              <DescriptionList>
                <DescriptionListItem
                  title="Место поставки (субъект РФ)"
                  definition={getDeliveryRegionName(item?.deliveryRegionCode)}
                />
                <DescriptionListItem
                  title="Место поставки (адрес)"
                  definition={item.deliveryAddress}
                />
              </DescriptionList>
            </>
          )}
        </details>
      ))}
    </>
  );
};

export default React.memo(LotItems);
